import { hot } from 'react-hot-loader/root';
import { BrowserRouter } from 'react-router-dom';

import App from './shared/pages/App';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { ErrorPage } from '@zg-rentals/visual-cohesion';
import { getErrorPageAction, getErrorPageTextProps } from './shared/utils/getErrorPageTextProps';
import { ZILLOW_RENTAL_MANAGER_SUBMIT_REQUEST } from './shared/constants/stringConstants';

const LeasingApp = () => (
  <RpErrorBoundary
    fallback={
      <ErrorPage
        errorMessage="Something went wrong on our end"
        errorDetails="Try refreshing the page. If that doesn’t work, check back in a few minutes."
        action={getErrorPageAction()}
        secondaryAction={<a href={ZILLOW_RENTAL_MANAGER_SUBMIT_REQUEST}>Contact support</a>}
      />
    }
    {...getErrorPageTextProps()}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </RpErrorBoundary>
);

export default hot(LeasingApp);
